import { OUT_OF_STOCK } from './availability';
import onError from '../utils/onError';

// Find or creates a container for our structured markup (written with JSON-LD https://json-ld.org/) to live in
export const addOrFindJsonLD = () => {
  let script = document.getElementById('dynamicJSONLD');

  if (!script) {
    script = document.createElement('script');
    script.setAttribute('type', 'application/ld+json');
    script.setAttribute('id', 'dynamicJSONLD');
    document.head.appendChild(script);
  }

  return script;
};

// Add markup that's easily consumed by Robots.
// See https://developers.google.com/search/docs/data-types/product for additional details.
// Because we have a single page app that simulates page loads (e.g. pushes history/updates data),
// this should be called everytime a SKU is selected.
export const updateStructuredMarkup = ({
  shopProduct,
  priceAndInventoryData,
}) => {
  try {
    if (shopProduct && priceAndInventoryData) {
      const script = addOrFindJsonLD();
      const priceAndInventoryForSku = priceAndInventoryData.variantBySkuId;
      const priceConverted =
        priceAndInventoryForSku?.price?.value === (null || undefined)
          ? undefined
          : (priceAndInventoryForSku.price.value / 100).toFixed(2); // Convert pennies to dollars.  E.G. 6800 to 68.00

      const offers = {
        '@type': 'Offer',
        sku: shopProduct.variantBySkuId?.sku,
        URL: shopProduct.variantBySkuId?.url,
        priceCurrency: priceAndInventoryForSku?.price?.currency,
        price: priceConverted,
        itemCondition: 'http://schema.org/NewCondition',
        availability:
          priceAndInventoryForSku?.inventory?.availability !== OUT_OF_STOCK
            ? 'https://schema.org/InStock'
            : 'https://schema.org/SoldOut',
      };

      const jsonLD = {
        '@context': 'https://schema.org/',
        '@type': 'Product',
        name: shopProduct?.name,
        brand: {
          '@type': 'Brand',
          name: shopProduct?.brand?.name,
        },
        sku: shopProduct.variantBySkuId?.sku,
        /* For SPM pages, we will currently have one "offer", which is the current
         selected variant on the page. Because of pagination, we aren't able
         to return all variants from SPM with price/inventory data at the moment.
         Shop enablement has this on their radar, and we will match the Visitor
         Product pages' multiple offers when we have that data available.
        */
        offers,
      };

      const content = JSON.stringify(jsonLD);

      script.textContent = content;

      // return for easy testing
      return content;
    }
  } catch (error) {
    onError(error);
  }

  return null;
};
